import React from "react";
import { Button } from "./ui/button";
import { Phone, MessageCircle, Globe } from "lucide-react";

const Header = ({ language, toggleLanguage }) => {
  const whatsappLink =
    "https://wa.me/34722886101?text=Hola%20ProntoFix%20Valencia%2C%20necesito%20ayuda%20con...";
  const phoneLink = "tel:+34722886101";

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
              <span className="text-[#2563EB]">Pronto</span>Fix Valencia
            </h1>
          </div>

          {/* CTA Buttons + Language Toggle */}
          <div className="flex items-center gap-2 sm:gap-3">
            {/* Language Toggle */}
            <button
              onClick={toggleLanguage}
              className="language-toggle p-2 rounded-lg hover:bg-gray-100 flex items-center gap-1 text-sm font-medium text-gray-700"
              aria-label="Toggle language"
            >
              <Globe className="w-4 h-4" />
              <span className="hidden sm:inline">{language === "es" ? "EN" : "ES"}</span>
            </button>

            {/* WhatsApp Button */}
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button
                className="bg-[#2563EB] hover:bg-[#1d4ed8] text-white px-3 sm:px-4 py-2 rounded-lg shadow-md flex items-center gap-2"
              >
                <MessageCircle className="w-4 h-4" />
                <span className="hidden sm:inline">WhatsApp</span>
              </Button>
            </a>

            {/* Call Button */}
            <a href={phoneLink}>
              <Button
                variant="outline"
                className="border-[#2563EB] text-[#2563EB] hover:bg-[#2563EB] hover:text-white px-3 sm:px-4 py-2 rounded-lg flex items-center gap-2"
              >
                <Phone className="w-4 h-4" />
                <span className="hidden sm:inline">
                  {language === "es" ? "Llamar" : "Call"}
                </span>
              </Button>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
